module.exports = __webpack_public_path__ + "media/img/pages/companies/covance-f685c6a26145987a77c455a54de66172.jpg";